import { apiClient } from './apiClient';

export const clicksignService = {
    getTemplates: async () => {
        const res = await apiClient.get('/clicksign/templates');
        return res.data;
    },

    uploadTemplate: async (file, nome, tipo = 'custom') => {
        const form = new FormData();
        form.append('file', file);
        form.append('nome', nome);
        form.append('tipo', tipo);
        const res = await apiClient.post('/clicksign/templates', form);
        return res.data;
    },

    toggleTemplate: async (id) => {
        const res = await apiClient.patch(`/clicksign/templates/${id}/toggle`);
        return res.data;
    },

    deleteTemplate: async (id) => {
        await apiClient.delete(`/clicksign/templates/${id}`);
    },

    getProcessoTemplates: async (processoId) => {
        const response = await apiClient.get(`/processos/${processoId}/templates`);
        return response.data;
    },

    uploadProcessoTemplate: async (processoId, file, nome, tipo = 'custom') => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('nome', nome);
        formData.append('tipo', tipo);
        const response = await apiClient.post(`/processos/${processoId}/templates`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    },

    deleteProcessoTemplate: async (processoId, templateId) => {
        await apiClient.delete(`/processos/${processoId}/templates/${templateId}`);
    },
};
